module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface001#pre01"
    }
  }, [_vm._v("General Editor’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "pre02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface002#pre02"
    }
  }, [_vm._v("Author’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "bib"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/bibliography#bib"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "int"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "int1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAVERY IN THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMAN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPIRE")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int1-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Status and Slaves")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int1-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("On Defining “Slavery”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int1-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Family Life for the Slave")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int1-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int1-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Pragmatics of Masters and Slaves")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int1-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int1-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Slavery, No Matter the Explanation")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int1-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int1-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F."), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "space015"
  }, [_vm._v("The Options for the Slave")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int1-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int1-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Runaway")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int1-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int1-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Manumission")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int1-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int1-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "space05"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("Christians and Slaves")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "int2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILEMON IN THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUCIBLE OF")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAVERY AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAVERY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODAY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "int3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III."), _c('span', {
    staticClass: "space"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORSHIP AND")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "int4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV."), _c('span', {
    staticClass: "space"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCIAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EALITIES OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILEMON")]), _vm._v(": R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNAWAY OR")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAVE IN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARCH OF A")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDIATOR")]), _vm._v("?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "int5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENTS AT")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK IN THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILEMON")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "int6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#int6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI."), _c('span', {
    staticClass: "space"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRUCTURE")]), _vm._v(", R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HETORIC AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LARITY OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILEMON")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TEXT AND COMMENTARY")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "space05"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("VV")]), _vm._v(". 1–3)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2-1-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Authors (v. 1a)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2-1-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Addressees (vv. 1b–2)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2-1-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Salutation (v. 3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANKSGIVING")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("VV")]), _vm._v(". 4–7)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPEAL FOR")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NESIMUS")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("VV")]), _vm._v(". 8–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2-3-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("First Appeal in the Sketch of the Scene (vv. 8–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2-3-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Second Appeal in the Presentation of Onesimus (vv. 12–16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2-3-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Third Appeal in their Partnership (vv. 17–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2-3-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Final Appeal in a Presence (v. 22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCLUSION")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("VV")]), _vm._v(". 23–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index003#idx003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture and Other Ancient Texts")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0